/*
  useSetPromise.js
*/

// Npm.
import { useCallback, useState, useEffect, useRef } from 'react';

/**
 * Hook for awaiting a supplied promise with a callback.
 */
export default function useSetPromise(callbackFunc) {

  const [promise, _setPromise] = useState(null);

  const callbackRef = useRef();
  callbackRef.current = (err, res) => {
    _setPromise(null);
    if (typeof callbackFunc === 'function') {
      callbackFunc(err, res);
    }
  };

  useEffect(() => {
    if (promise) {
      let subbed = true;
      promise.then(res => {
        if (subbed) {
          callbackRef.current(null, res);
        }
      }).catch(err => {
        if (subbed) {
          callbackRef.current(err, null);
        }
      });
      return () => {
        subbed = false;
      };
    }
  }, [promise]);

  const setPromise = useCallback((val) => {
    if (val != null) {
      const prom = Promise.resolve(val);
      prom.catch(err => {
        // Add a catch immediately to stop "uncaught error" which may error the react app.
      });
      _setPromise(prom);
    } else {
      _setPromise(null);
    }
  }, [_setPromise]);

  return [promise, setPromise];

}